import {
  CONSUMER_PROTECTION_RECOMMENDATION_LINK,
  HOW_TO_SPOT_SOLAR_PANEL_SCAMS_LINK,
  NEVER_SIGN_A_SOLAR_LOAN_BEFORE_CHECKING_THIS,
  ROOFTOP_SOLAR_ENERGY_CONTRACT_LINK,
  SOLAR_DEALER_FEES_LINK,
} from '@oneethos/shared'
import AgreementCheckbox from '../../components/agreement-checkbox'
import { SubformProps } from '../'

const consumerLinks = [
  {
    title: 'What are solar dealer fees and why should I care?',
    url: SOLAR_DEALER_FEES_LINK
  },
  {
    title: 'Consumer Protection Recommendation',
    url: CONSUMER_PROTECTION_RECOMMENDATION_LINK
  },
  {
    title: 'How to spot solar panel scams?',
    url: HOW_TO_SPOT_SOLAR_PANEL_SCAMS_LINK
  },
  {
    title: 'Understanding Your Rooftop Solar Energy Contract',
    url: ROOFTOP_SOLAR_ENERGY_CONTRACT_LINK
  },
  {
    title: 'Never sign a solar loan before checking this',
    url: NEVER_SIGN_A_SOLAR_LOAN_BEFORE_CHECKING_THIS
  }
]

export const ConsumerResourceLinks = ({ formData, update }: Partial<SubformProps>) => {
  return <>
    <div className='d-flex flex-column mb-4'>
      {consumerLinks.map((link) => (
        <a key={link.title} href={link.url} target="_blank" rel="noopener noreferrer" className='mb-1'>
          {link.title}
        </a>
      ))}
    </div>
    <AgreementCheckbox
      formData={formData}
      update={update}
      name="attestConsumerResourceUnderstanding"
    >
      I understand these resources are provided to help me make an informed decision
      regarding my solar project and related lending options
    </AgreementCheckbox>
  </>
}

